import defaultKy, { type KyInstance } from "ky";

export namespace ytrank {
  export interface Transcript {
    duration: number;
    start: number;
    text: string;
  }
  export interface Response {
    transcript: Transcript[];
  }

  export interface YTRankClientOptions {
    apiBaseUrl?: string;
    apiUserAgent?: string;
    ky?: KyInstance;
  }
}

export class YTRankClient {
  protected readonly ky: KyInstance;
  protected readonly apiBaseUrl: string;
  protected readonly apiUserAgent: string;

  constructor({
    apiBaseUrl = "https://ytrank.com",
    apiUserAgent = "toollm",
    ky = defaultKy,
  }: ytrank.YTRankClientOptions = {}) {
    this.apiBaseUrl = apiBaseUrl;
    this.apiUserAgent = apiUserAgent;

    this.ky = ky.extend({
      prefixUrl: apiBaseUrl,
      headers: {
        "user-agent": apiUserAgent,
      },
    });
  }

  async getTranscript(_url: string) {
    return this.ky.get("/api/fetchtranscript").json<ytrank.Response>();
  }
}
